import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import Modal from '../common/Modal';
import Button from '../common/Button';
import Loading from '../common/Loading';

const AssignAssociationToSimpleModal = ({ simple, onClose, onSuccess }) => {
  const { user } = useAuth();
  const [associations, setAssociations] = useState([]);
  const [selectedAssociationId, setSelectedAssociationId] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchAssociations();
  }, []);

  const fetchAssociations = async () => {
    try {
      const response = await api.get(`/associations/owner/${user.id}`);
      setAssociations(response.data.data);
      
      // Pré-sélectionner l'association actuelle s'il existe
      if (simple.associationId) {
        setSelectedAssociationId(simple.associationId._id || simple.associationId);
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAssign = async () => {
    if (!selectedAssociationId) {
      alert('Veuillez sélectionner une association');
      return;
    }

    setSubmitting(true);
    try {
      await api.patch(`/simples/${simple._id}/assign-association`, {
        associationId: selectedAssociationId,
      });
      alert('Association assignée avec succès');
      onSuccess();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur lors de l\'assignation');
    } finally {
      setSubmitting(false);
    }
  };

  const handleUnassign = async () => {
    if (!window.confirm('Retirer l\'association de ce Simple ?')) {
      return;
    }

    setSubmitting(true);
    try {
      await api.patch(`/simples/${simple._id}/unassign-association`);
      alert('Association retirée avec succès');
      onSuccess();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <Modal isOpen={true} onClose={onClose} title="Chargement..."><Loading /></Modal>;

  return (
    <Modal isOpen={true} onClose={onClose} title="🔗 Assigner une Association">
      <div className="space-y-4">
        <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
          <p className="text-sm text-gray-700">
            <strong>User Simple :</strong> {simple.name}
          </p>
          <p className="text-sm text-gray-600 mt-1">
            {simple.email}
          </p>
        </div>

        {/* Info règle */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <p className="text-xs text-blue-800">
            ℹ️ <strong>Règle :</strong> Un User Simple ne peut avoir qu'<strong>une seule</strong> association à la fois.
          </p>
        </div>

        {/* Sélection Association */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Sélectionner une association
          </label>
          <select
            value={selectedAssociationId}
            onChange={(e) => setSelectedAssociationId(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-primary"
          >
            <option value="">-- Aucune association --</option>
            {associations.map((assoc) => (
              <option key={assoc._id} value={assoc._id}>
                {assoc.name} ({assoc.sensorId?.name} → {assoc.switchId?.name})
              </option>
            ))}
          </select>
        </div>

        {associations.length === 0 && (
          <p className="text-sm text-red-600">
            Aucune association disponible. Demandez à votre administrateur de vous en assigner.
          </p>
        )}

        {/* Current Association */}
        {simple.associationId && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <p className="text-sm text-gray-700">
              <strong>Association actuelle :</strong>{' '}
              {simple.associationId.name || 'N/A'}
            </p>
          </div>
        )}

        {/* Boutons */}
        <div className="flex space-x-3 pt-4 border-t">
          {simple.associationId && (
            <Button
              variant="danger"
              onClick={handleUnassign}
              disabled={submitting}
              className="flex-1"
            >
              {submitting ? 'En cours...' : '❌ Retirer'}
            </Button>
          )}
          <Button
            onClick={handleAssign}
            disabled={submitting || !selectedAssociationId}
            className="flex-1"
          >
            {submitting ? 'En cours...' : '✅ Assigner'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AssignAssociationToSimpleModal;